import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import CommonLoader from '../../source/CommonLoader';
//import AnnouncementNotificationCommon from '../../source/WebScreen/Notification/AnnouncementNotificationCommon'
//import NotificationCommon from '../../source/WebScreen/Notification/NotificationCommon'
import HealthTools from '../../source/WebScreen/HeathTools/HealthTools';

import Routes from '../../routes.js';
import { getProperEmailId, getUserDetails } from '../../actions/homeActions';
import { getDecryptIdAPI } from '../../source/ApiCall';
import PaymentWalletServiceCloud from '../../source/WebScreen/PaymentWallet/PaymentWalletServiceCloud';
import Signup from './CheckRegistration';
import Signin from './SignIn';

const CustomAuth = (props) => {
    const [toggle, setToggle] = useState(false);
    const [loadCommonComponent, setLoadCommonComponent] = useState(false);
    const [urlPath, setUrlPath] = useState(false);
    const history = useHistory();
    useEffect(() => {
        console.log('props from custom auth', props)
        StateParam();

    }, [])

    const StateParam = async () => {
      try {
        let queryParams = new URLSearchParams(window.location.search)
        if (queryParams.has('admin')) {
          localStorage.setItem('isAdmin', 'true')
        }
        if (queryParams.has('reimbursement') && queryParams.get('reimbursement') === 'true') {
          sessionStorage.setItem('REDIRECT_REIMBURSEMENT_ONLY', 'true')
        }

        if (queryParams.has('SC') && queryParams.get('SC') === 'true') {
          localStorage.setItem('isServiceCloud', 'true')
        }

        if (queryParams.has('email')) {
          localStorage.setItem('initiatedUser', queryParams.get('email'))
        }

        let urlValues = window.location.hash ? window.location.hash.split('=') : []
        console.log('=== Restored Hash Array urlValues ===', urlValues)

        const hash = window.location.hash

        if (hash && hash.includes('state=')) {
          setLoadCommonComponent(true)

          const encryptedStateToken = hash.split('state=')[1]

          if (encryptedStateToken) {
            const decodedToken = decodeURIComponent(encryptedStateToken)

            await getGateWayToken(decodedToken)

            return
          }
        }
        setLoadCommonComponent(false)
      } catch (err) {
        console.error('StateParam Error:', err)
        setLoadCommonComponent(false)
      }
    }

    const getGateWayToken = async params => {
      try {
        let request = {
          username: process.env.REACT_APP_GETWAY_TOKEN_USERNAME,
          password: process.env.REACT_APP_GETWAY_TOKEN_PASS
        }

        const data = await axios.post(process.env.REACT_APP_BASE_URL + 'v1/login', request)

        let bearer = data.headers.authorization

        if (!bearer) {
          throw new Error('Bearer token missing')
        }

        var array = bearer.split('Bearer ')

        localStorage.setItem('bearerToken', array[1])

        await getDecodeData(params)
      } catch (err) {
        console.error('Gateway token error:', err)
        setLoadCommonComponent(false)
      }
    }


    const getuserData = async data => {
      try {
        let email = await getProperEmailId(data)

        let userData = await getUserDetails(email)

        if (userData) {
          let find = userData.data.memberIdCardList[userData.data.memberIdCardList.length - 1]

          localStorage.setItem('SOURCE', find.source)

          localStorage.setItem('sourceid', userData.data.memberIdCardList[0].memberId)

          localStorage.setItem('CLIENT_ID', find.clientId)

          localStorage.setItem('userMail', email)

          sessionStorage.setItem('USER_ACTIVE_SESSION', 'true')

          localStorage.setItem('popupShow', 'true')

          localStorage.setItem('planId', userData.data.memberIdCardList[0].planId)

          localStorage.setItem('subscriberName', `${userData.data.memberIdCardList[0].firstName || ''}`)

          // IMPORTANT
          localStorage.setItem('isLogged', 'true')

          // REMOVE HASH URL
          window.history.replaceState({}, document.title, '/')

          setUrlPath(true)

          setLoadCommonComponent(true)
        }
      } catch (err) {
        console.error('User data error:', err)

        setLoadCommonComponent(false)

        history.push('/login')
      }
    }

    const getDecodeData = async data => {
      try {
        const resp = await getDecryptIdAPI(data)

        console.log('Decrypted response:', resp)

        if (resp && typeof resp === 'string') {
          const lowercasePayload = resp.toLowerCase()

          if (lowercasePayload.includes('reimbursement')) {
            sessionStorage.setItem('REDIRECT_REIMBURSEMENT_ONLY', 'true')
          }
        }

        await getuserData(resp)
      } catch (err) {
        console.error('Decryption failed:', err)

        setLoadCommonComponent(false)
      }
    }

    const handleToggle = () => {
        setToggle(!toggle);
    }

    const isReimbursementPath = window.location.pathname.toLowerCase() === '/myreimbursement' || 
                                window.location.hash.toLowerCase().includes('myreimbursement');

    if (isReimbursementPath) {
        return (
            <Switch>
                <Routes />
            </Switch>
        );
    }
    
    if(loadCommonComponent) {
        return(<div>
            { urlPath ? 
                <Switch>
                     <Routes/>
                </Switch>
                :<div><CommonLoader/></div>
            }
            
       </div>)
    }else{
        return (
            <Switch>
                <Route exact path="/login" component={Signin} />
                <Route exact path="/check-registration" component={Signup} />
                <Redirect from="/" to="/login" />
    
            </Switch>
        )
    }

}
export default CustomAuth

